import React from 'react';
import { node, string } from 'prop-types';
import { Box, Typography } from '@mui/material';

const EmptyState = ({ icon, text }) => {
  return (
    <Box
      bgcolor="graphic.lighter"
      color="graphic.main"
      display="flex"
      height="80"
      justifyContent="space-between"
      p={3}
      width={1}
    >
      {icon}
      <Typography sx={{ pl: 3 }} variant="body2">
        {text}
      </Typography>
    </Box>
  );
};

export default EmptyState;

EmptyState.propTypes = {
  icon: node.isRequired,
  text: string.isRequired,
};
